import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HRAuthContext = createContext(null);

export const useHRAuth = () => {
    const context = useContext(HRAuthContext);
    if (!context) {
        throw new Error('useHRAuth must be used within an HRAuthProvider');
    }
    return context;
};

export const HRAuthProvider = ({ children }) => {
    const [manager, setManager] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const checkAuth = async () => {
        try {
            const response = await axios.get(`${API}/hr/me`, {
                withCredentials: true
            });
            setManager(response.data);
            setIsAuthenticated(true);
        } catch (error) {
            setManager(null);
            setIsAuthenticated(false);
        } finally {
            setIsLoading(false);
        }
    };

    const login = async (email, password) => {
        const response = await axios.post(
            `${API}/hr/login`,
            { email, password },
            { withCredentials: true }
        );
        setManager(response.data);
        setIsAuthenticated(true);
        return response.data;
    };

    const logout = async () => {
        try {
            await axios.post(`${API}/hr/logout`, {}, {
                withCredentials: true
            });
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            setManager(null);
            setIsAuthenticated(false);
        }
    };

    useEffect(() => {
        checkAuth();
    }, []);

    const value = {
        manager,
        isAuthenticated,
        isLoading,
        login,
        logout,
        checkAuth
    };

    return (
        <HRAuthContext.Provider value={value}>
            {children}
        </HRAuthContext.Provider>
    );
};
